import { render, staticRenderFns } from "./courseIndex.vue?vue&type=template&id=e195f260"
import script from "./courseIndex.vue?vue&type=script&lang=js"
export * from "./courseIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports